import { useState } from 'react';
import { Button, showToast, OpenInNewIcon } from '@attentive-platform/stem-ui';
import { FormContainer, InputContainer, FlexItem, ErrorText } from '../../styled';
import { EmailInput } from '../../uicomponents';
import { isValidEmail } from '../../Utils/HelperFunctions';
import { fetchApiData } from '../../Utils/ApiCalls';
import { SUPPORT_SESSION_ISSUE_HANDOFF_HASH } from '../../urls';

export const SupportSession = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [handoff, setHandoff] = useState(null);

  const onChangeHandler = (_key, value) => {
    setEmail(value);
    setHandoff(null);
  };

  const trimmedEmail = email.trim();

  const handleSubmit = async () => {
    setLoading(true);
    setHandoff(null);
    const { data, error } = await fetchApiData({
      endpoint: SUPPORT_SESSION_ISSUE_HANDOFF_HASH,
      apiRequest: 'POST',
      data: { email: trimmedEmail.toLowerCase() }
    });
    setLoading(false);
    if (error || !data?.handoff_url) {
      showToast(typeof error === 'string' ? error : 'Could not issue link', 'error');
      return;
    }
    try {
      const url = new URL(data.handoff_url);
      setHandoff({ fullUrl: data.handoff_url, path: `${url.pathname}${url.search}`, expiresAt: data.expires_at });
    } catch {
      showToast('Could not issue link', 'error');
    }
  };

  const disabledCta = !trimmedEmail || !isValidEmail(trimmedEmail) || loading;

  return (
    <FormContainer>
      <InputContainer>
        <FlexItem>
          <EmailInput
            value={email}
            onChange={onChangeHandler}
            name='support-session-email'
            showError={false}
            disabled={loading}
            width='100%'
          />
        </FlexItem>
        <div>
          <Button disabled={disabledCta} loading={loading} color='primary' onClick={handleSubmit}>
            {loading ? 'Generating link' : 'Generate session link'}
          </Button>
        </div>
      </InputContainer>
      {email && !isValidEmail(trimmedEmail) && <ErrorText>Invalid email</ErrorText>}
      {handoff && (
        <div>
          <div>
            <strong>Session link:</strong>{' '}
            <a href={handoff.fullUrl} target='_blank' rel='noopener noreferrer'>
              {handoff.fullUrl} <OpenInNewIcon fontSize='small' />
            </a>
          </div>
          <div>
            <strong>Expires:</strong> {new Date(handoff.expiresAt).toLocaleString()}
          </div>
        </div>
      )}
    </FormContainer>
  );
};

export default SupportSession;
